import { render, staticRenderFns } from "./Wh5eAuthChoose.vue?vue&type=template&id=0a8de326&scoped=true"
import script from "./Wh5eAuthChoose.vue?vue&type=script&lang=js"
export * from "./Wh5eAuthChoose.vue?vue&type=script&lang=js"
import style0 from "./Wh5eAuthChoose.vue?vue&type=style&index=0&id=0a8de326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8de326",
  null
  
)

export default component.exports